import { render, staticRenderFns } from "./YuebaoRecord.vue?vue&type=template&id=c2faa224&scoped=true"
import script from "./YuebaoRecord.vue?vue&type=script&lang=js"
export * from "./YuebaoRecord.vue?vue&type=script&lang=js"
import style0 from "./YuebaoRecord.vue?vue&type=style&index=0&id=c2faa224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2faa224",
  null
  
)

export default component.exports